import { createSelector } from 'reselect';

const selectsmallbanner = state => state.smallBanner;

export const selectSmallBanner = createSelector(
    [selectsmallbanner],
    (banner) => banner.smallBanner
)

export const selectSmallBannerLoading = createSelector(
    [selectsmallbanner],
    (banner) => banner.isFetching
)